import type { LocaleObject, NuxtI18nOptions } from "@nuxtjs/i18n";
import { STORE_CONFIG } from "./store.config";
import {
  AllowedLocales,
  AllowedStores,
  SearchProvider,
  StoreConfig,
} from "../types/i18n";

export const I18N_STORES: StoreConfig[] = [
  {
    code: AllowedStores.ee,
    domain: STORE_CONFIG.eeStoreUrl,
    locales: [AllowedLocales.et, AllowedLocales.en, AllowedLocales.ru],
    priceFormat: {
      currency: "EUR",
      decimal: ".",
    },
  },
  {
    code: AllowedStores.lt,
    domain: STORE_CONFIG.ltStoreUrl,
    locales: [AllowedLocales.lt, AllowedLocales.en, AllowedLocales.ru],
    priceFormat: {
      currency: "EUR",
      decimal: ".",
    },
  },
  {
    code: AllowedStores.lv,
    domain: STORE_CONFIG.lvStoreUrl,
    locales: [AllowedLocales.lv, AllowedLocales.en, AllowedLocales.ru],
    priceFormat: {
      currency: "EUR",
      decimal: ".",
    },
  },
  {
    code: AllowedStores.fi,
    domain: STORE_CONFIG.fiStoreUrl,
    locales: [AllowedLocales.fi, AllowedLocales.en],
    priceFormat: {
      currency: "EUR",
      decimal: ".",
    },
  },
  {
    code: AllowedStores.za,
    domain: STORE_CONFIG.zaStoreUrl,
    locales: [AllowedLocales.en],
    localeFiles: {
      [AllowedLocales.en]: "en-za.json",
    },
    priceFormat: {
      currency: "ZAR",
      decimal: ",",
      symbol: "R",
    },
    searchProvider: SearchProvider.magento,
  },
];

export const I18N_CONFIG: NuxtI18nOptions = {
  locales: I18N_STORES.reduce((locales: LocaleObject[], store: StoreConfig) => {
    store.locales.forEach((storeLocale: AllowedLocales) => {
      // Add store locale to locales config
      locales.push({
        code: storeLocale,
        file: store.localeFiles?.[storeLocale] || `${storeLocale}.json`,
        iso: storeLocale,
        inheritLocale: false,
      });
    });

    return locales;
  }, []),
  langDir: "i18n",
  lazy: true,
  detectBrowserLanguage: false,
  strategy: "prefix_except_default",
  differentDomains: false,
  debug: false,
  // vueI18n: "./vueI18n.config.ts",
};
